import React, { useEffect, useState } from 'react'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import { Grid } from '@mui/material'
import { format } from 'date-fns'
import clsx from 'clsx'
import Loading from '@Components/Loading/Loading'
import { connect } from 'react-redux'

interface IDetailReportModal {
    open?: any
    onClose?: any
    listData?: any
    detail?: any
    educatorLoadingModal?: boolean
}

const DetailReportModal = (props: IDetailReportModal) => {
    const { open, onClose, listData, detail, educatorLoadingModal } = props

    useEffect(() => {
        console.log(detail)
    }, [detail])

    return (
        <>
            <CustomModal
                onClose={() => onClose()}
                open={open}
                modalTitle={`FILE ${
                    listData?.reference ? `${listData?.reference}` : ''
                } ${listData?.deptCode ? `${listData?.deptCode}` : ''}`}
            >
                <div className="modal-body">
                    <Loading isLoading={educatorLoadingModal} />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6}>
                            <div className="page-border page-radius p-2 mb-3">
                                <p className="font-weight-bold mb-0">Student</p>
                                <p className="fs-14 mb-0">
                                    {detail?.firstName}&nbsp;
                                    {detail?.middleName}&nbsp;
                                    {detail?.lastName}
                                </p>
                                {detail?.dob && (
                                    <p className="fs-14 mb-0">
                                        {format(
                                            new Date(detail?.dob),
                                            'yyyy-MM-dd'
                                        )}
                                    </p>
                                )}
                                <p className="fs-14 mb-0">
                                    {detail?.address}&nbsp;{detail?.city?.name}
                                    &nbsp;
                                    {detail?.state?.name}&nbsp;
                                    {detail?.zip}
                                </p>
                            </div>
                            <div className="page-border page-radius p-2">
                                <p className="font-weight-bold mb-0">Parents</p>
                                {detail?.parents?.map((item: any) => {
                                    return (
                                        <div key={item?.id} className="mb-3">
                                            <p className="fs-14 mb-0">
                                                {item?.firstName}&nbsp;
                                                {item?.middleName}&nbsp;
                                                {item?.lastName}
                                            </p>
                                            <p className="fs-14 mb-0">
                                                {item?.relationship}
                                            </p>
                                            <p className="fs-14 mb-0">
                                                {item?.phone}
                                            </p>
                                            <p className="fs-14 mb-0">
                                                {item?.address}&nbsp;
                                                {item?.city?.name}&nbsp;
                                                {item?.state?.name}&nbsp;
                                                {item?.zip}
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <div className="page-border page-radius p-2">
                                <p className="font-weight-bold mb-1">
                                    Firearms
                                </p>
                                {!detail?.items?.length && (
                                    <p className="no-data">No Data!</p>
                                )}
                                {detail?.items?.length > 0 &&
                                    detail?.items?.map(
                                        (item: any, i: number) => {
                                            return (
                                                <React.Fragment key={item?.id}>
                                                    <div className="w-100 d-flex my-2">
                                                        <div
                                                            className="w-50 text-center"
                                                            style={{
                                                                height: '80px',
                                                            }}
                                                        >
                                                            <img
                                                                className={clsx(
                                                                    'mw-100 h-100 page-radius',
                                                                    !item?.imageUrl
                                                                        ? 'object-scale-down'
                                                                        : ''
                                                                )}
                                                                src={`require(${item?.imageUrl}).default`}
                                                                alt=""
                                                                onError={(
                                                                    e: any
                                                                ) => {
                                                                    e.target.onerror =
                                                                        null
                                                                    e.target.src =
                                                                        item?.imageUrl ||
                                                                        require('@Images/icons/camera-icon.svg')
                                                                            .default
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="ml-2 w-50">
                                                            <p className="fs-12 mb-0">
                                                                <span className="text-gray">
                                                                    Owner:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {
                                                                        item
                                                                            ?.owner
                                                                            ?.firstName
                                                                    }
                                                                    &nbsp;
                                                                    {
                                                                        item
                                                                            ?.owner
                                                                            ?.middleName
                                                                    }
                                                                    &nbsp;
                                                                    {
                                                                        item
                                                                            ?.owner
                                                                            ?.lastName
                                                                    }
                                                                </span>
                                                                <br />
                                                                <span className="text-gray">
                                                                    Make:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {
                                                                        item
                                                                            ?.make
                                                                            ?.name
                                                                    }
                                                                </span>
                                                                <br />
                                                                <span className="text-gray">
                                                                    Model:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {
                                                                        item
                                                                            ?.model
                                                                            ?.name
                                                                    }
                                                                </span>
                                                                <br />
                                                                <span className="text-gray">
                                                                    Caliber:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {
                                                                        item
                                                                            ?.caliber
                                                                            ?.name
                                                                    }
                                                                </span>
                                                                <br />
                                                                <span className="text-gray">
                                                                    Serial:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {item?.serialCode
                                                                        ? `#${item?.serialCode}`
                                                                        : ''}
                                                                </span>
                                                                <br />
                                                                <span className="text-gray">
                                                                    Capacity:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {
                                                                        item?.capacity
                                                                    }
                                                                </span>
                                                                <br />
                                                                <span className="text-gray">
                                                                    Date of
                                                                    Purchase:{' '}
                                                                </span>
                                                                <span className="text-black font-weight-bold">
                                                                    {
                                                                        item?.capacity
                                                                    }
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {detail?.items?.length -
                                                        1 !==
                                                        i && (
                                                        <div className="page-hr" />
                                                    )}
                                                </React.Fragment>
                                            )
                                        }
                                    )}
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </CustomModal>
        </>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { educatorLoadingModal } = store?.educator?.educatorInfo
    return {
        educatorLoadingModal,
    }
}

export default connect(mapStateToProps, null)(DetailReportModal)
